import React from 'react'
import ZhagaNodeView from './ZhagaNodeView/ZhagaNodeView'
import { useSingleStreetLight } from '../../../../hooks'

export default function ZhagaNode() {
  const {singleStreetLightQuery} = useSingleStreetLight()

  if(!singleStreetLightQuery.data?.str_light_zhaga_devui){
    return <></>
  }

  return (
    <ZhagaNodeView devui={singleStreetLightQuery.data?.str_light_zhaga_devui} />
  )
}
 